// Recherche + tri des aliments pour le sélecteur cherchable (FoodPicker).
import type { Food } from './types';

/** Normalise pour une recherche insensible casse/accents. */
function norm(s: string): string {
  return s
    .toLowerCase()
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '');
}

export interface FoodOption extends Food {
  isFavorite: boolean;
}

/**
 * Filtre les aliments par sous-chaîne du nom (insensible casse/accents) et trie :
 * favoris d'abord, puis alphabétique. `query` vide → tous les aliments.
 */
export function searchFoods(
  foods: readonly Food[],
  favoriteIds: ReadonlySet<string>,
  query: string,
): FoodOption[] {
  const q = norm(query.trim());
  const matches = q ? foods.filter((f) => norm(f.name).includes(q)) : foods.slice();
  return matches
    .map((f) => ({ ...f, isFavorite: favoriteIds.has(f.id) }))
    .sort((a, b) => {
      if (a.isFavorite !== b.isFavorite) return a.isFavorite ? -1 : 1;
      return a.name.localeCompare(b.name, 'fr');
    });
}
